import { type TableHeaderRow } from '@shared/table-generator';

export const itemSetQuestionChangeTableHeaders: TableHeaderRow[] = [
  {
    children: [
      {
        id: 'question-change-checkbox',
        children: null,
        rowSpan: 1,
        sx: {
          width: '48px',
        },
      },
      {
        id: 'question-change-item-set-qid',
        children: 'name',
        align: 'center',
        rowSpan: 1,
        sx: {
          flex: 1,
        },
      },
      {
        id: 'question-change-qid',
        children: 'QID',
        align: 'center',
        rowSpan: 1,
        sx: {
          width: '170px',
        },
      },
      {
        id: 'question-change-difficulty',
        children: 'ระดับความยาก',
        align: 'center',
        rowSpan: 1,
        sx: {
          width: '100px',
        },
      },
      {
        id: 'question-change-question-type',
        children: 'ประเภทข้อสอบ',
        align: 'center',
        rowSpan: 1,
        sx: {
          width: '100px',
        },
      },
      {
        id: 'question-change-question-status',
        children: 'สถานะการใช้งาน',
        align: 'center',
        rowSpan: 1,
        sx: {
          width: '150px',
        },
      },
      {
        id: 'question-change-action',
        children: 'Action',
        align: 'center',
        rowSpan: 1,
        sx: {
          width: '124px',
        },
      },
    ],
  },
];
